
import React, {useEffect, useState} from "react";
// import {GContext} from "../context/GContext";
import BasicSection from "../component/BasicSection";
import OneFeature, {Circle} from "../component/OneFeature";
import OneCard from "../component/OneCard";

import './HomePage.scss'
import useProductSystem from "./useProductSystem";
import ProductFeatureMobile from "../component/ProductFeatureMobile";
import DataAnaMobile from "../component/DataAnaMobile";
import TopNav from "../component/TopNav";

// 获取二级域名，不考虑IP
// 跟罗总重新沟通，
// const getCurrentDomain = function (){
//     return document.domain.split('.').slice(-2).join('.')
// }


// 底部备案信息
const FooterBeian = function (){
    const {domain} = document;
    if(domain.indexOf('hy.tt')>-1){
        return (
            <div>&copy; 2023 hy.tt All Rights Reserved</div>
        )
    }
    return (
        <div>
            <div>
                &copy; 2023 tota123.com All Rights Reserved:<a href="https://beian.miit.gov.cn">粤ICP备17102981号-1</a>
            </div>
            <div>
                深圳市通腾网络科技有限公司版权所有
            </div>
            <div className="small beian">
                <img src={require("../asset/beian.png")} className={'beian-img'} alt={'备案'} />
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002001170" rel="noreferrer"
                   target="_blank">粤公网安备44030002001170号</a>
            </div>

        </div>
    )
}


export default function HomePage(){
    // const g = useContext(GContext);

    // animate__slideInDown

    useEffect(()=>{
        window.addEventListener("scroll",function (){
            for (const element of document.querySelectorAll(".default-animation")) {
                // 检查元素是否在可视区域内
                if (element.getBoundingClientRect().top < window.innerHeight) {
                    // 添加 fadeIn 类
                    element.classList.add("animate__fadeIn","animate__animated");
                }
            }
        })
    },[])

    const [scale, setScale] = useState(1);

    const setTransScale=function(){
        const width = Math.max(window.innerWidth,320);
        const scale = width / 1000; // 1000 应该能正常显示下了
        // console.log(scale);
         setScale(scale <1 ?0.5 :1);//0.5是适配手机的，否则就是WEB端
    }
    // tt-cloud-tag-wrapper 部分缩小
    useEffect(()=>{
        setTransScale()
        window.addEventListener('resize',function (){
            setTransScale();
        })
    },[])


    const {setShowMore, showMore,finalList} = useProductSystem({
        totalList:SystemList,
    });


    return (
        <div className="App">
            <header className="App-header">
                <div className={'nav-wrapper'}>
                    <div className={'tt-main-logo'} />
                    <TopNav />
                </div>

                <h1>智慧收银&nbsp;&nbsp;&nbsp;连接会员</h1>
                <h2>一款以会员为核心，帮助商家发展会员、沉淀会员、留存会员，建立忠诚会员以及支持多种收款方式的会员营销+收银APP，一个手机App实现多平台管理同时支持软硬结合兼容多款设备。</h2>
            </header>
            <BasicSection
                h1={"轻应用、强功能"}
                h2={
                    <>
                        <div>降低机具依赖性和功能单一性，不止是收银，更是商户的综合管理平台。</div>
                        <div>真正帮商户低成本实现线上线下一体化，帮助商家零成本和低门槛打通“店商+电商”，自助经营私有会员池，提升获客、留存和复购能力。</div>
                    </>
                }

                bgType={'light-app'}
            >
                <div className={'extra'}>

                    <OneFeature type={1} img={require("../asset/icon-app.png")} title={"商户App"} content={"商户端提供APP管理"}/>
                    <OneFeature type={1} img={require("../asset/icon-miniprogram.png")} title={"用户小程序"} content={"用户端提供小程序和H5服务"} />
                    <div className="flex1"></div>
                    <img className={'app-preview'} src={require("../asset/app-preview.png")} alt={'app-preview'}/>
                </div>

            </BasicSection>
            <BasicSection id={"product-feature"} bgType={"green-section"} h1={"产品特点"} h2={"TT会员根据行业类别和交易规模对商户分层 提供更多的适配服务，能满足不同的市场需求。"}>
                <div className={'product-feature'}>
                    {ProductFeatureList.map(one=>(
                        <OneFeature key={one.key} type={2} customImg={
                            <Circle content={one.key} />
                        } title={one.title} content={one.content}/>
                    ))}
                </div>
                <ProductFeatureMobile list={ProductFeatureList} />


            </BasicSection>
            <BasicSection h2={'TT会员根据行业类别和交易规模对商户分层，一个手机App实现多平台管理，同时支持软硬结合，兼容多款设备，提供更多的适配服务，能满足不同的市场需求。'} >
                <div className={'tt-cloud-tag-wrapper'}>
                    <img src={require("../asset/tt-icon.png")} style={{width:194*scale,height:192*scale}} alt={'icon'}/>
                    <span style={{left:-180*scale,top:-14*scale}}>云端扫码盒</span>
                    <span style={{left:-250*scale,top:90*scale}} className={'primary'}>云端小票打印机</span>
                    <span style={{left:-180*scale,top:(90+104)*scale}}>云喇叭</span>

                    <span style={{right:-120*scale,top:-14*scale}} className={'primary'}>PAD平板</span>
                    <span style={{right:-200*scale,top:90*scale}}>刷脸机</span>
                    <span style={{right:-150*scale,top:(90+104)*scale}} className={'primary'}>会员读卡器</span>
                </div>
            </BasicSection>
            <BasicSection id={'product-introduce'} h1={"产品介绍"} bgType={'system-section '+(scale < 1 ? 'green-section':'')} style={scale < 1 ?{}:{backgroundImage:`url(${require("../asset/system-bg.png")})`, backgroundSize:"contain"}}>
                <div className="system-list">
                    {finalList.map((sys,index)=>(
                        <div className="system-wrapper default-animation" key={index}>
                            <OneFeature  type={3} title={sys.title} content={sys.content} img={sys.img} />
                        </div>
                    ))}
                    {showMore &&
                        <button className={'button'} style={{marginTop:20}} onClick={()=>{setShowMore(false);console.log('123')}}>更多</button>}
                </div>
            </BasicSection>

            <BasicSection h1={"适配行业"} h2={<>
                <div>支持单店、连锁店、商圈，产品涵盖零售市场不同行业、不同规模、不同形态的海量数据。</div>
                <div>商户适合单店、各类连锁、购物中心、物业、景区、城市级管理等。</div>
            </>} >
                <div className="card-wrapper">
                    {CardList.map((one,index)=>(
                        <OneCard key={index} title={one.title} content={one.content} />
                    ))}
                </div>
                <DataAnaMobile list={CardList} />


            </BasicSection>
            <BasicSection bgType={"green-section map-section"} id={'about-us'}>
                <div className="intro">
                    <div className="intro-left">
                        <h3>关于我们</h3>
                        <div className={'intro-detail'}>
                            一款以会员为核心，帮助商家发展会员、沉淀会员、留存会员，建立忠诚会员以及支持多种收款方式的会员营销+收银APP，一个手机App实现多平台管理同时支持软硬结合兼容多款设备。
                        </div>

                        <div className={'ul-wrapper'}>
                            <ul>
                                <li className="address">深圳市南山区桃源街道桃源社区北环大道方大广场(一期)3、4号研发楼3号楼1106</li>
                                <li className="phone"><a href="tel://075586008488">0755-86008488</a></li>
                            </ul>
                        </div>

                    </div>
                    <div className="intro-right"></div>
                </div>
            </BasicSection>

            <section className="app_download">

                <img src={require('../asset/app_download.png')} title="app下载" alt="app下载" />
                <div>APP下载</div>
            </section>
            <footer>
                <section className="footer-wrapper">
                    <div className={'app-download-wrapper'}>
                        <img src={require('../asset/app_download.png')} title="app下载" alt="app下载" className={'app-download-img'}/>
                        <a className={'app-download-text'} href={'https://static.tota123.com/i.html#download'}>APP下载</a>
                    </div>

                    <FooterBeian />


                </section>

            </footer>
        </div>
    )
}





const CardList = [{
    title:"实体店铺",
    content: <>
        <p>餐饮、零售、娱乐</p>
        <p>美容、美发、美甲</p>
        <p>健身、培训、洗车</p>
        <p>摄影、酒店、民宿</p>
        <p>房车营地、露营基地</p>
        <p>满足各行各业经营需求</p>
    </>
},{
    title:"中型连锁",
    content:<p>帮助连锁商户实现多门店连锁业 态的全渠道一体化经营，打通会员、商品、储值、营销、数据。 总分店，连锁店，加盟店</p>
},{
    title:"大型商圈",
    content:"为园区、景区、及大型商业综合体提供 商圈级解决方案，提供线上线下打通的 一卡通方案。超大型商圈，工业园， Shopping Mall"
}]

const ProductFeatureList = [{
    key:"01",
    title:"自助进件",
    content:<>
        <div>商户通过App</div>
        <div>自助进件开通支付</div>
    </>
},{
    key:"02",
    title:"快速上手",
    content:<>
        <div>业务经理到店</div>
        <div>5分钟培训上手</div>
    </>
},{
    key:"03",
    title:"支付即会员",
    content:<>
        <div>支付即会员</div>
        <div>自动将顾客转化为会员</div>
    </>
},{
    key:"04",
    title:"单店通用",
    content:"单店版，即可拥有最核心的\"商城小程序\"和\"会员功能\""
},{
    key:"05",
    title:"软硬结合",
    content:"软硬件结合，商户可根据自身需求选配各种配件"
},{
    key:"06",
    title: "丰富组件",
    content:"一个商家App即可适配不同行业业务场景，商户可根据需求开启更多组件"
},{
    key:"07",
    title:"无缝升级",
    content:"单店可无缝升级连锁版，无需更换任何硬件或版本"
}]

const SystemList = [{
    title:"收银系统",
    content:"提供全方位的收银渠道：云闪付、微信、 支付宝、现金、会员卡、pos机。",
    img:require('../asset/system-cashier.png')
},{
    title:"点单系统",
    content: "提供两种点单模式：店员系统代客下单， 和顾客自助二维码点单。",
    img:require('../asset/system-order.png')
},{
    title: "会员系统",
    content:"提供会员码、会员等级、会员储值、会员优惠等，帮助商家沉淀会员提升活跃 度，提高留存，最终提升服务价值及收入。",
    img:require('../asset/system-member.png')
},{
    title:"营销系统",
    content:"提供线上派券、爆款秒杀、积分兑换、 减价折扣等营销工具，让商户优惠直接触达顾客，提升复购率。",
    img:require('../asset/system-marketing.png')
},{
    title:'微店系统',
    content:"免申请免注册、免费微店，线上下单、 配送核销，助力商户实现线上售卖商品，打通线上线下一体化经营。",
    img:require('../asset/system-minishop.png')
},{
    title:'门店管理系统',
    content:"提供多收银台管理、多店员管理、货架管理、订单管理等功能来提高商户经营管理能效。",
    img:require('../asset/system-store.png')
},{
    title:'数据分析系统',
    content:"提供收款汇总、对账明细、销售统计、卡券统计、店员统计等，数字化门店经营/运营/财务数据，实时助力商户生意决策。",
    img:require('../asset/system-statistics.png')
},{
    title:'连锁系统',
    content:'数据全面打通、线上赋能门店、高效利用资金、数据实时统计分析、库存配置更加合理、兼容多类连锁业态。',
    img:require('../asset/system-chain.png')
},{
    title:'行业组件',
    content: '服务行业、高级零售库存、推广返利、外卖配送、移动收款单、餐饮、预订管理、刷脸支付等组件。',
    img:require('../asset/system-component.png')
}]
